export default __webpack_public_path__ + "static/media/telaresistor5.c4ff8782.png";